<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">SECTION D: SCHOLARSHIPS / TUITION ASSISTANCE / AWARDS</p>
                    </div>
                    <div>
                        <p>Scholarships and tuition assistance are available using university funds allocated for students who need additional financial aid.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr></b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div class="mt-3">
                        <p>
                            <strong>Award Performance Maintenance Criteria:</strong>
                        </p>
                        <ul>
                            <li>Continuously participate in courses to meet programmatic completion milestones (unless taking an approved Leave of Absence).</li>
                            <li>Maintain a minimum cumulative course grade of 80% on each component of the course (quizzes, Observations, micro-teaching, and practicum).</li>
                            <li>Avoid any disciplinary action, professional misconduct, or academic honesty violations for any reason.</li>
                        </ul>
                        <p>
                            <strong>Repayment Obligation:</strong> If a student who was awarded any scholarship or tuition assistance withdraws or is dismissed from the Continuing Education program for any reason,
                            they are required to pay the award amount back for all course components completed since the award was issued.
                        </p>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-ce-d"
                                        v-model="form.status"
                                        name="checkbox-ce-d"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>
                                    <p>
                                        I read and confirm that I understand the information in Section D.
                                    </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    props: {
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
            data: [],
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const info = this.studentInformation;
            this.data.push(
                {
                    key: 'Type of Awarded Program Assistance',
                    value: info?.scholarship_name ?? '–',
                },
                {
                    key: 'Total Assistance Amount Awarded',
                    value: info?.total_discount_amount ? `$${this.currencyFormat(info.total_discount_amount)}` : '–',
                },
            )
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
